import React from 'react';
import { withTranslation } from 'react-i18next';
import { ModalBody } from 'reactstrap';
import { modalWrapper } from 'components/FDModal';
import Loader from 'assets/images/loader.gif';
import { callSetPaymentAPI, callRedirectToACSAPI } from 'actions/payment';
import DisplayError from "components/FDModal/display-error";
import { RenderForm } from 'components/Common'

class LoaderAndCallSetPayment extends React.Component {

    getPaymentTypeCode(paymentType){
        switch(paymentType){
            case 'CREDITCARD':
                return 'CC';
            case 'DEBITCARD':
                return 'DC';
            case 'IDEBIT':
                return 'IDC';
            default:
                return 'CC';
        }
    }

    state = { transaction: false }
    componentDidMount() {
        let setPaymentData = {}
        const selectedPaymentTypeCode = this.getPaymentTypeCode(this.props.selectedPayment)
        callSetPaymentAPI(selectedPaymentTypeCode, setPaymentData, this.props.txnKey, this.props.txnIv).then((resp) => {
            this.setState({paymentResponse: resp.data})
            const { errorCode, errorMessage, iDebitUrl, selfOTPBin, selfOTPTermUrl, is3DSecure, isRupayCard, threeDSecureRequest, rupayCardRequestBean } = resp.data
            const non3DSecure = !(selfOTPBin || is3DSecure || isRupayCard)
            this.setState({ iDebitUrl, is3DSecure, selfOTPBin, selfOTPTermUrl, isRupayCard, threeDSecureRequest, rupayCardRequestBean, non3DSecure })
            if (errorCode) {
                this.setState({ loader: false })
                this.canDisplayErrorModal(errorCode, errorMessage)
            } else if (selfOTPBin) {
                callRedirectToACSAPI().then((resp)=>{
                    const { is3DSecure, threeDSecureRequest } = resp.data
                    this.setState({is3DSecure, threeDSecureRequest})
                    if(resp.data.errorCode){
                        this.canDisplayErrorModal(errorCode, errorMessage)
                    }else if(is3DSecure){
                        this.setState({transaction: true})
                        if(!threeDSecureRequest.is3ds2Integration) {
                            document.ACSFORM.submit();
                        } else {
                            if(threeDSecureRequest.tdsFlow === 'CHL') {
                                document.creq.submit();
                            }
                        }                         
                    }
                })
            } else if (is3DSecure) {
                this.setState({ transaction: true })
                if(!threeDSecureRequest.is3ds2Integration) {
                    document.ACSFORM.submit();
                } else {
                    if(threeDSecureRequest.tdsFlow === 'CHL') {
                        document.creq.submit();
                    }
                }                 
            } else if (iDebitUrl) {
                this.setState({ transaction: true })
                document.IDEBITFORM.submit();
            } else if (non3DSecure) {
                this.setState({ transaction: true })
                this.setState({ non3DSecureUrl: resp.data.redirectUrl })
                document.NON3DSECUREFORM.submit();
            }
        }).catch((error) => {
            // console.log("Card Error: ", error);
            this.setState({ loader: false })
        });
    }

    canDisplayErrorModal(errCode, errMsg){
        if(errCode==='FPDR4025'){
            this.setState({displayError: true, errMsg})
        }else if(errCode==='FPDR5029'){
            this.setState({displayError: true, errMsg})
        }
    }

    render() {
        const { t } = this.props
        return (
            <ModalBody>
                <div style={{ 'textAlign': 'center' }}>
                    <img src={Loader} alt="Loader" />
                    <p></p>
                    {
                        !this.state.transaction &&
                        <p className="text-16">{t('Please do not refresh the page')}</p>
                    }
                    {
                        this.state.transaction &&
                        <>
                            <p className="text-16">{t('You will be redirected to your banks website')}</p>
                            <p className="text-16">{t('It might take a few seconds')}</p>
                            <p className="text-16">{t('Please DO NOT refresh')}</p>
                        </>
                    }
                </div>
                { this.state.displayError &&  <DisplayError errMsg={this.state.errMsg} /> }
                <div className='hidden'>
                    <RenderForm iDebitUrl={this.state.iDebitUrl} is3DSecure={this.state.is3DSecure} isRupayCard={this.state.isRupayCard} threeDSecureRequest={this.state.threeDSecureRequest} rupayCardRequestBean={this.state.rupayCardRequestBean} formName='CC' non3DSecure={this.state.non3DSecure} non3DSecureUrl={this.state.non3DSecureUrl} />
                </div>
            </ModalBody>
        )
    }
}

export default withTranslation('translations')(modalWrapper(true, "LoaderAndCallSetPaymentModal")(LoaderAndCallSetPayment));